/* eslint-disable react-hooks/exhaustive-deps */
import {
  ArrowDownOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  LineChartOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Button, Col, DatePicker, Empty, message, Modal, Popconfirm, Popover, Row, Select, Tag, Tooltip, } from 'antd';
import introJs from 'intro.js';
import { Steps as StepsIntro } from 'intro.js-react';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import IconCameraEmpty from '../../assets/icons/camera-empty.svg';
import IconDecryptionButton from '../../assets/icons/decryption-button.svg';
import IconExclamation from '../../assets/icons/exclamation.svg';
import IconPlayButton from '../../assets/icons/play-button.svg';
import IntroButtonAdd from '../../assets/images/intro-button-add.png';
import IntroTabRtsp from '../../assets/images/intro-tab-rtsp.png';
import Thumbnail from '../../assets/images/thumbnail.jpg';
import PlayerComponent from '../../components/Player';
import Spinner from '../../components/Spinner';
import * as SERVICE from '../../constants/service.types';
import {
  generateLinkStorageFileReturn,
  removeStorageFileReturn,
  resetCameraStorageReturn,
  setListStorageFileByTag,
  setOpenUploadFilesModal,
  setPlayVideoAtPage,
  setUploadFilesCamera,
  setUploadFilesDate,
  setUploadFilesOldVideos,
  socketEmitEvent,
} from '../../redux/actions';
import { downloadFile } from '../../untils/download';
import SearchVideosModal from './SearchVideosModal/SearchVideosModal';
import VideoInformation from './VideoInformation';
import SystemMessage from './SystemMessage';

const { Option } = Select;
const { confirm } = Modal;

const StorageVideoComponent = ({
  dispatch,
  serial,
  handleAddCamera,
  permission,
  selectCamera,
}) => {
  const { t } = useTranslation();
  const {
    cameraStorage,
    decryptData,
    playVideoAtPage,
    namespace,
    camerasDate,
    dataUser,
    lastVisited,
    uploadStorageFile,
    servicesCamera,
    removeStorageFile,
    uploadFilesCamera,
  } = useSelector((state) => state);
  const popoverRef = useRef(null);

  const [ipAddress, setIpAddress] = useState('0.0.0.0');
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setDownloading] = useState(false);
  const [dateRecord, setDateRecord] = useState(moment());
  const [timeRecord, setTimeRecord] = useState();
  const [data, setData] = useState();
  const [timePicker, setTimePicker] = useState(1000);
  const [videos, setVideos] = useState();
  const [dataSelectSource, setDataSelectSource] = useState();
  const [dataSteps, setDataSteps] = useState([
    {
      element: '.intro-add-camera',
      intro: (
        <div>
          <img
            alt=""
            style={{ width: '100%', marginBottom: '8px' }}
            src={IntroButtonAdd}
          />
          <div>{t('Nhấn vào nút “Add camera”')}</div>
          <img
            alt=""
            style={{ width: '100%', margin: '16px 0px 8px' }}
            src={IntroTabRtsp}
          />
          <div>{t('Sau đó chọn “RTSP link”')}</div>
        </div>
      ),
    },
  ]);
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);

  const [isUploadVideo, setIsUploadVideo] = useState(false);
  const [dataRequestId, setDataRequestId] = useState(new Date().getTime());

  const [isOpenSearchVideosModal, setOpenSearchVideosModal] = useState(false);
  const [downloadVideos, setDownloadVideos] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (dataUser) {
      if (!lastVisited && localStorage.getItem('tutorial') === '1') {
        setTimeout(() => {
          setStepsEnabled(true);
        }, 300);
      }
    }
  }, [dataUser]);

  useEffect(() => {
    setTimeout(() => {
      introJs().start();
    }, 300);
    return () => {
      dispatch(resetCameraStorageReturn());
      introJs().exit();
    };
  }, []);

  useEffect(() => {
    function sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }
    async function onDecrypt(callback) {
      await sleep(2000);
      return callback();
    }

    if (
      decryptData &&
      playVideoAtPage === 'PLAY_VIDEO_IN_STORAGE_VIDEO'
    ) {
      onDecrypt(() => {
        setVideos((state) =>
          state?.map((video) =>
            video?.recordId !== decryptData.recordId &&
            !video?.dataRecordIds?.find((item) => item === decryptData.recordId)
              ? video
              : {
                  ...video,
                  decrypting: false,
                  secureLink: decryptData.secureLink,
                }
          )
        );
      });
    } else if (
      decryptData &&
      playVideoAtPage === 'DOWNLOAD_VIDEO_IN_STORAGE_VIDEO'
    ) {
      if (decryptData.secureLink && downloadVideos?.length > 0) {
        setDownloading(true);
        downloadFile({
          url: decryptData.secureLink,
          fileName: decryptData.fileName,
          isSaveAs: decryptData.fileName ? true : false,
        });
        setTimeout(() => {
          setDownloadVideos(
            downloadVideos?.filter(
              (item) => item?.recordId !== decryptData.recordId
            )
          );
          setDownloading(false);
        }, 5000);
      }
    }
  }, [decryptData, ipAddress, playVideoAtPage]);

  useEffect(() => {
    if (downloadVideos?.length > 0 && ipAddress) {
      let dataBody = {
        ipAddress,
        recordId: downloadVideos?.[0]?.recordId,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.GENERATE_LINK_STORAGE_FILE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(setPlayVideoAtPage('DOWNLOAD_VIDEO_IN_STORAGE_VIDEO'));
      dispatch(socketEmitEvent(dataObj));
    }
  }, [downloadVideos]);

  const handleDownloadVideo = (isDownload, dataVideos) => {
    confirm({
      title: t('Are you sure to download videos?'),
      icon: <ExclamationCircleOutlined />,

      onOk() {
        setDownloadVideos(dataVideos);
      },
      onCancel() {},
    });
  };

  useEffect(() => {
    if (cameraStorage) {
      let times = [];
      cameraStorage.map(
        (video) =>
          !times.some((time) => time.value - 100 === video.hour) &&
          times.push({
            value: video.hour + 100,
            title: `${video.hour < 10 ? '0' + video.hour : video.hour}:00 - ${
              video.hour === 23
                ? '00'
                : video.hour < 9
                ? '0' + (video.hour + 1)
                : video.hour + 1
            }:00`,
          })
      );

      setTimeRecord(times);
      setData(cameraStorage.reverse());
      setIsLoading(false);
    }
  }, [cameraStorage]);

  useEffect(() => {
    if (data && timePicker) {
      let videos = [];
      data.map((video) => {
        if (
          !videos?.find(
            (item) => item.from === video.from && item.minute === video.minute
          )
        ) {
          const dataTemp = data?.filter(
            (item) => item.from === video.from && item.minute === video.minute
          );
          videos.push({
            ...video,
            loading: false,
            dataRecordIds: dataTemp?.map((item) => item.recordId),
          });
        }
      });
      videos.sort((a, b) => {
        return b?.from?.localeCompare(a?.from, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      });
      if (timePicker === 1000) {
        setVideos(videos);
      } else {
        setVideos(videos.filter((video) => video.hour === timePicker - 100));
      }
    }
  }, [data, timePicker]);

  const onLogService = async (serial) => {
    const timeRequest = new Date().getTime();
    let data = {
      timeRequest,
      namespace,
      serial,
    };
    let dataObj = {
      appServiceType: SERVICE.LIST_SERVICE_BY_DEVICE_SERIAL,
      requestId: timeRequest,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  useEffect(() => {
    if (selectCamera) {
      onLogService(selectCamera.serial);
    }
  }, [selectCamera]);

  useEffect(() => {
    if (servicesCamera) {
      setIsUploadVideo(
        servicesCamera?.find((item) => item.id === 10 && item.licenseCode) &&
          selectCamera?.permission
            ?.split('_')
            ?.find((item) => item === 'upload')
      );
    }
  }, [servicesCamera]);

  const onViewVideo = (recordId, encrypted) => {
    setVideos((state) =>
      state.map((video) =>
        video?.recordId !== recordId &&
        !video?.dataRecordIds?.find((item) => item === recordId)
          ? video
          : { ...video, loading: true, decrypting: encrypted }
      )
    );

    if ((recordId, ipAddress)) {
      let dataBody = {
        ipAddress,
        recordId,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.GENERATE_LINK_STORAGE_FILE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };

      dispatch(setPlayVideoAtPage('PLAY_VIDEO_IN_STORAGE_VIDEO'));
      return dispatch(socketEmitEvent(dataObj));
    }
  };

  const getListStorage = useCallback(
    (serial, dateRecord) => {
      let data = {
        serial,
        dateRecord: dateRecord.format('YYYY-MM-DD'),
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_CAMERA_STORAGE_FILE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };

      dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace]
  );

  const getListStorageDate = useCallback(
    (serial) => {
      let data = {
        serial,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_CAMERA_STORAGE_FILE_DATE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };

      dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace]
  );

  useEffect(() => {
    if (dateRecord && serial) {
      getListStorage(serial, dateRecord);
      setIsLoading(true);
    }
  }, [dateRecord, getListStorage, serial]);

  useEffect(() => {
    if (serial) {
      getListStorageDate(serial);
    }
  }, [getListStorageDate, serial]);

  useEffect(() => {
    // cập nhật list video khi upload 1 video thành công
    if (
      uploadStorageFile?.isSuccess &&
      selectCamera &&
      uploadStorageFile?.data.serial === selectCamera?.serial
    ) {
      getListStorage(serial, dateRecord);
      setIsLoading(true);
    }
  }, [uploadStorageFile]);

  useEffect(() => {
    if (removeStorageFile === dataRequestId) {
      dispatch(removeStorageFileReturn(null));
      getListStorage(serial, dateRecord);
      setIsLoading(true);
    }
  }, [removeStorageFile]);

  const handleReportActionLog = (logContent, logSerial) => {
    let data = {
      action: 'Download',
      content: logContent,
      namespace,
      serial: logSerial,
    };
    let dataObj = {
      appServiceType: SERVICE.REPORT_ACTION_LOG,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
  };

  const showModalUpload = () => {
    // lưu thông tin chung: camera, video cũ trong ngày upload, ngày upload
    // nếu đang chưa xử lý upload
    if (!uploadFilesCamera) {
      dispatch(setUploadFilesCamera(selectCamera));
      dispatch(setUploadFilesDate(dateRecord));
      dispatch(setUploadFilesOldVideos(videos));
      dispatch(setOpenUploadFilesModal(true));
    } else {
      message.warning('There is another camera processing the video upload');
    }
  };

  const handleDeleteRecord = (dataVideo) => {
    const timeRequest = new Date().getTime();
    let data = {
      serial: dataVideo.serial,
      namespace,
      recordId: dataVideo.recordId,
    };
    let dataObj = {
      appServiceType: SERVICE.REMOVE_STORAGE_FILE,
      requestId: timeRequest,
      body: JSON.stringify(data),
    };
    setDataRequestId(timeRequest);
    dispatch(socketEmitEvent(dataObj));
  };

  const handleClosePopup = (visible) => {
    setVisible(false);
  };

  return (
    <div className="storage-video-component">
      <div className="header-storage-component">
        <div className="picker-side" style={{ display: 'flex' }}>
          <DatePicker
            dateRender={(current) => {
              const style = {};
              if (
                camerasDate &&
                camerasDate.find((x) => x === current.format('MM-DD-YYYY'))
              ) {
                style.color = 'rgba(255, 255, 255, 0.85)';
                style.borderBottom = '1px solid #0e9347';
              }
              return (
                <div className="ant-picker-cell-inner" style={style}>
                  {current.date()}
                </div>
              );
            }}
            className="picker"
            format="DD-MM-YYYY"
            placeholder={t('Select date')}
            defaultValue={dateRecord}
            disabled={!serial}
            style={{
              width: '255px',
              marginLeft: '20px',
              height: '32px',
              marginRight: '20px',
            }}
            onChange={(value) => setDateRecord(value)}
          />
          <Select
            className="picker"
            defaultValue={1000}
            disabled={!timeRecord}
            onChange={(times) => setTimePicker(times)}
            style={{ width: '255px', height: '32px' }}
          >
            <Option value={1000}>{t('All time')}</Option>
            {timeRecord &&
              timeRecord.map((time, index) => (
                <Option key={index} value={time.value}>
                  {time.title}
                </Option>
              ))}
          </Select>
        </div>
        <div
          className="add-camera"
        >
          <Popover
            ref={popoverRef}
            placement="bottomRight"
            title={null}
            content={<SystemMessage handleClosePopup={handleClosePopup} />}
            overlayClassName="system_message_popup"
            trigger="click"
            visible={visible}
            onVisibleChange={(visible) => {
              return setVisible(visible);
            }}
            maskClosable={false}
          >
            <Button
              icon={<LineChartOutlined />}
              style={{ marginRight: 20 }}
              title="Disconnect event"
            >
              {t('Analytics')}
            </Button>
          </Popover>
          {videos?.length > 0 &&
            permission?.split('_')?.find((item) => item === 'download') && (
              <Button
                loading={isDownloading}
                onClick={() => handleDownloadVideo(true, videos)}
                icon={<ArrowDownOutlined />}
                style={{ marginRight: 20 }}
              >
                {t('Download videos')}
              </Button>
            )}
          <Button
            onClick={() => setOpenSearchVideosModal(true)}
            icon={<SearchOutlined />}
            style={{ marginRight: 20 }}
          >
            {t('Search')}
          </Button>
          <Button
            className="intro-add-camera"
            icon={<PlusOutlined />}
            size="middle"
            onClick={() => {
              handleAddCamera();
              introJs().exit();
            }}
          >
            {t('Add camera')}
          </Button>
        </div>
      </div>

      <div className="center-storage-component">
        {!isLoading ? (
          videos ? (
            videos.length > 0 ? (
              <Row gutter={[8, 8]}>
                <Col xs={24} md={12} lg={8}>
                  <div className="child-video upload-video-camera">
                    <Tooltip title={t('Upload video')}>
                      <div
                        className="add-button"
                        style={{
                          cursor: isUploadVideo ? 'pointer' : 'not-allowed',
                        }}
                        onClick={() => {
                          if (isUploadVideo) {
                            showModalUpload();
                          }
                        }}
                      >
                        <PlusOutlined
                          style={{
                            fontSize: 60,
                            color: isUploadVideo
                              ? 'rgb(198 198 198)'
                              : '#4f4d4d',
                          }}
                        />
                      </div>
                    </Tooltip>
                  </div>
                </Col>
                {videos.map((video) => (
                  <Col key={video.recordId} xs={24} md={12} lg={8}>
                    <div className="main-child-video">
                      <div className="streaming-video">
                        <PlayerComponent
                          type="video"
                          loading={video.loading}
                          permission={permission && permission.split('_')}
                          src={video.secureLink && video.secureLink}
                          poster={
                            video.thumbnail && video.thumbnail.match(/http/g)
                              ? video.thumbnail
                              : Thumbnail
                          }
                          logContent={JSON.stringify({
                            recordId: video.recordId,
                            isSaveAs: decryptData?.fileName ? true : false,
                            cameraName:
                              decryptData?.fileName ||
                              video.fileName?.replace('.mp4', ''),
                            actionDate: moment(video.recordDate).format(
                              'DD-MM-YYYY'
                            ),
                          })}
                          logSerial={video.serial}
                          handleReportActionLog={handleReportActionLog}
                          dateTime={`${
                            moment(video?.recordDate).format('DD-MM-YYYY') ?? ''
                          }_${video?.from?.replaceAll(':', '-') ?? ''}_${
                            video?.to?.replaceAll(':', '-') ?? ''
                          }`}
                        />
                        {video.decrypting && (
                          <div className="decrypt no-select">
                            {t('Decrypting...')}
                          </div>
                        )}
                        {video && !video.loading && !video.secureLink && (
                          <>
                            {
                              permission &&
                                permission.split('_') &&
                                permission
                                  .split('_')
                                  .find(
                                    (item) =>
                                      item === 'playback' || item === 'download'
                                  ) && (
                                  <img
                                    onClick={() => {
                                      onViewVideo(
                                        dataSelectSource?.find(
                                          (item) => item?.id === video.recordId
                                        )?.selectRecordId ?? video.recordId,
                                        video.encrypt !== 'none'
                                      );
                                    }}
                                    className="icon-play"
                                    src={
                                      video.encrypt === 'none'
                                        ? IconPlayButton
                                        : IconDecryptionButton
                                    }
                                    alt="play-button"
                                  />
                                )
                            }
                          </>
                        )}
                      </div>

                      <div className="description">
                        <div className="des">{`${video.from} - ${video.to}`}</div>
                        <div style={{ display: 'flex' }}>
                          <div style={{ marginRight: 10, marginLeft: 10 }}>
                            {video.tags && (
                              <Tag style={{ margin: 3 }}>
                                <>
                                  {video.tags.split(';')[0].slice(0, 20)}{' '}
                                  {(video.tags.split(';').length > 1 ||
                                    video.tags.split(';')[0].length > 20) && (
                                    <span>...</span>
                                  )}
                                </>
                              </Tag>
                            )}
                          </div>
                          <Popover
                            trigger="click"
                            placement="topRight"
                            content={
                              <VideoInformation
                                video={video}
                                onUpdateVideoTagsSuccess={() =>
                                  getListStorage(serial, dateRecord)
                                }
                                dataSelectSource={dataSelectSource}
                                setDataSelectSource={setDataSelectSource}
                              />
                            }
                            title={t('Video information')}
                          >
                            <Tooltip title={t('Video information')}>
                              <div className="icon-question">
                                <img src={IconExclamation} alt="question" />
                              </div>
                            </Tooltip>
                          </Popover>
                          {video.state === 'manual_upload' &&
                            dataUser.role === 'admin' && (
                              <Popconfirm
                                title="Are you sure to delete this record?"
                                onConfirm={() => handleDeleteRecord(video)}
                                okText="Yes"
                                cancelText="No"
                              >
                                <Tooltip title={t('Delete')}>
                                  <DeleteOutlined
                                    style={{
                                      marginLeft: '16px',
                                      fontSize: '20px',
                                      color: 'rgb(245, 47, 57)',
                                    }}
                                  />
                                </Tooltip>
                              </Popconfirm>
                            )}
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            ) : (
              <Row gutter={[8, 8]}>
                <Col xs={24} md={12} lg={8}>
                  <div className="child-video upload-video-camera">
                    <Tooltip title={t('Upload video')}>
                      <div
                        className="add-button"
                        style={{
                          cursor: isUploadVideo ? 'pointer' : 'not-allowed',
                        }}
                        onClick={() => {
                          if (isUploadVideo) {
                            showModalUpload();
                          }
                        }}
                      >
                        <PlusOutlined
                          style={{
                            fontSize: 60,
                            color: isUploadVideo
                              ? 'rgb(198 198 198)'
                              : '#4f4d4d',
                          }}
                        />
                      </div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
            )
          ) : (
            <div className="empty-video">
              <Empty
                image={IconCameraEmpty}
                imageStyle={{
                  height: 100,
                }}
                description={<span>{t('No cameras are selected!')}</span>}
              />
            </div>
          )
        ) : (
          <Spinner />
        )}
      </div>
      <StepsIntro
        enabled={stepsEnabled}
        steps={dataSteps}
        initialStep={initialStep}
        onExit={() => setStepsEnabled(false)}
      />

      {isOpenSearchVideosModal && (
        <SearchVideosModal
          onClose={() => {
            setOpenSearchVideosModal(false);
            dispatch(setListStorageFileByTag(null));
            dispatch(generateLinkStorageFileReturn(null));
          }}
        />
      )}
    </div>
  );
};

export default StorageVideoComponent;
